module.exports = __webpack_public_path__ + "img/Group 1084one.c7ae0917.png";